import React, {useState, useLayoutEffect} from 'react';
import {connect} from 'react-redux';
import FormCheck from 'jd-library/FormCheck';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';

import styles from './styles.scss';
import { handleOnChange, handleCheckBoxOnChange, handleOnBlur } from '../../customActions';


function CheckboxContainer(props) {

    const {
        item = {},
        handleOnChange,
        parentIndex,
        handleCheckBoxOnChange,
        handleOnBlur,
        isSellOnline
    } = props

    const {
        s_dnm,
        s_nm,
        s_type_options,
        textBoxIsHidden = false,
        userInput,
        s_mandatory,
        s_re_mandatory
    } = item;

    const [checkboxOptions, setCheckboxOptions] = useState([]);
    const [errorCheck, setErrorCheck] = useState(props.err == "Required Field" ? true : false)    

    let inputOptions = {};

    useLayoutEffect(() => {
       
        if(userInput.value && Array.isArray(userInput.value) && userInput.value.length){
            setCheckboxOptions(userInput.value);
        }else{
            const options = s_type_options.map((itm, index) => {
                return {
                    key: index,
                    label: itm,
                    checked: userInput.value && !Array.isArray(userInput.value) && userInput.value==itm ? true : false
                }
            })
            setCheckboxOptions(options);
        }
    }, []);

    useLayoutEffect(() => {
        if(props.err == 'Required Field'){
            setErrorCheck(true)
        }else {
            setErrorCheck(false)
        }
    }, [props.err])

    function handleOnCheckboxChange(e, index){
        const checkedCheckboxes = checkboxOptions.map((checkbox_item, checkbox_index) => {
            if(checkbox_index == index){
                checkbox_item.checked = e.target.checked
            }
            return checkbox_item;
        });

        handleCheckBoxOnChange({
            data: checkedCheckboxes,
            parentIndex,
            item
        })
        if(props.item.userInput.value){
            let checked = props.item.userInput.value.find(x => x.checked === true)
            if (checked){
                setErrorCheck(false)
            }else {
                setErrorCheck(true) 
            }
        }
    }



    if(item.isDependentTextBox){
        inputOptions = {
            label: "Other Details" || "",
            holderClass: styles["dependent-text-field"],
            input:{
                value: userInput.textboxValue,
                type: 'text',
                name: s_nm,
                autoFocus: userInput.textboxValue? false: true,
                onChange: (e) => handleOnChange({e, parentIndex, item, key: "textboxValue",isSellOnline}),
                onBlur: (e) => handleOnBlur({e, parentIndex, item, key: "textboxError", isDependentTextBox: true}),
                readOnly: (props?.isEnrichSpec) ? true : false
            },
            errorMessage: userInput.textboxError,
            infoMessage:!userInput.textboxError && (props.showSellOnline || props.isService  ? s_mandatory =='1' : s_re_mandatory == '1') && !props.session.viaOmni && !props.isAuditor ? 'Required Field':''
        }
    }

    return (
        <div className={styles["checkbox-depended-child-wrapper"]}>
            <div className={styles["checkbox-heading"]}>
                { s_dnm || ""}
            </div>
            <div className={styles["checkbox-form-control"]}>
                {checkboxOptions.length && checkboxOptions.map((checkboxItem, index) => {
                    return <FormCheck
                        labelClass={styles["checkbox-label"]}
                        className={styles["checkbox-control"]}
                        key={`${checkboxItem.label}_${index}`}
                        onChange={(e) => handleOnCheckboxChange(e, index)}
                        label={checkboxItem.label}
                        checked={checkboxItem.checked}
                        disabled={props?.isEnrichSpec ? true : false} 
                        err={errorCheck}
                        />
                }) || null}
            </div>
            {textBoxIsHidden && (
                <div className={styles['dependent-textbox-container']}>
                    <InputWithMovingLabel {...inputOptions} />
                </div>
            )}
            {props.item.s_mandatory || props.item.s_re_mandatory ? (
                <div className={`checkbox-required-field ${errorCheck ? 'error-red' : ''}`}>Required Field</div> 
            ) : null}
        </div>
    )
}

const mapStateToProps  = (state, props) => {
    return {
        ...props,
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex],
        isSellOnline: state.products.editProduct.isSellOnline || props.showSellOnline,
        session: state.session,
        isService: state.products.editProduct.categoryType == 'service',
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR"
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleOnChange : (payload) => dispatch(handleOnChange(payload)),
        handleCheckBoxOnChange: (payload) => handleCheckBoxOnChange(payload, dispatch),
        handleOnBlur: (payload) => dispatch(handleOnBlur(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxContainer);
